// ======================================================================
// File Name       : enterpriseNotificationConstant
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const EnterpriseNotificationPublicStatus = [
  { name: '非公開', value: 0 },
  { name: '公開', value: 1 },
];

export const EnterpriseNotificationReleaseTargetForEnterprise = [
  { name: '自企業内', value: 0 },
  { name: '従属企業全体', value: 1 },
];
